<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-商品内容
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--商品详情-->
    <div class="common-form">下单说明</div>
    <!--内容-->
    <el-form-item label="说明内容：">
      <div class="edit_container">
        <Uediter :text="form.model.orderContent" :config="ueditor.config" ref="ue3" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>
    <!--商品图片组件-->
    <Upload v-if="is_upload" :config="config" :isupload="is_upload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Uediter from "@/components/UE3.vue";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
export default {
  components: {
    /*编辑器*/
    Uediter,
    Upload,
    draggable
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text3: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      is_upload: false,
      config: {
        total: 9,
        fileType: "image"
      }
    };
  },
  created() {
    this.ueditor.text = this.form.model.orderContent;
  },
  inject: ["form"],
  methods: {
    /*获取富文本框内容*/
    getContent: function() {
      return this.$refs.ue3.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e) {
      console.log(2222, e);
      this.form.model.orderContent = e;
    },
    openUpload() {
      this.is_upload = true;
    },
    /*上传商品图片*/
    returnImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.contentImage.concat(e);
        this.$set(this.form.model, "contentImage", imgs);
      }
      this.is_upload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.contentImage.splice(index, 1);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.vue